import type { Selection } from "./types";

const DRAFT_KEY = "pbct.draft.v1";
const PLANS_KEY = "pbct.plans.v1";

export function loadDraft(): Selection | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    return raw ? (JSON.parse(raw) as Selection) : null;
  } catch {
    return null;
  }
}

export function saveDraft(s: Selection): void {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(s));
  } catch {
    // ignore quota errors — they're not fatal for a draft
  }
}

// Saved plans (keyed by class date) — for future "load past plan" feature.
export interface SavedPlan {
  savedAt: string;
  selection: Selection;
}

export function listSavedPlans(): Record<string, SavedPlan> {
  try {
    const raw = localStorage.getItem(PLANS_KEY);
    return raw ? (JSON.parse(raw) as Record<string, SavedPlan>) : {};
  } catch {
    return {};
  }
}

export function savePlan(key: string, s: Selection): void {
  const all = listSavedPlans();
  all[key] = { savedAt: new Date().toISOString(), selection: s };
  localStorage.setItem(PLANS_KEY, JSON.stringify(all));
}
